<template>
  <div class="scroll-x-items lg:flex-wrap">
    <div
      v-for="(item, index) in breadcrumb"
      :key="index"
      class="scroll-x-items__item"
    >
      <BaseLink
        tag="a"
        :url="item.link.link_with_query_strings"
      >
        <span class="flex items-center">
          <span
            class="whitespace-nowrap inline-block text__button-link-xs--regular lg:text__button-link-md--regular"
            :class="[index !== breadcrumb.length - 1 ? 'text-label-text' : 'text-primary']"
          >
            {{ item.anchor }}
          </span>
          <BaseIcon
            v-if="index !== breadcrumb.length - 1"
            size="xs"
            color="icon-text-field"
            name="keyboard_arrow_right"
            class="mx-2"
          />
        </span>
      </BaseLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BreadcrumbPages',
  props: {
    breadcrumb: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style lang="scss">
@mixin hide-scroll {
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.scroll-x-items {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  @include hide-scroll;
}
</style>
